exports.createServer =
exports.createConnection =
exports.connect =
function () {};

exports.isIP =
exports.isIPv4 =
exports.isIPv6 =
function () { return true };




//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/mock/net.js
// module id = 648
// module chunks = 0